module.exports = __webpack_public_path__ + "img/weapons.5a8f4f1d.svg";